// extracted by mini-css-extract-plugin
var _1 = "_H5NDN";
var _2 = "_lBMsB";
var _3 = "_B6y7N";
var _4 = "_Dl5IH";
var _5 = "_DxIOn";
var _6 = "_cZitR";
var _7 = "_Nj8pM";
var _8 = "_bBULy";
export { _1 as "bluePill", _2 as "disabledPill", _3 as "greenPill", _4 as "pill", _5 as "pillText", _6 as "redPill", _7 as "silverPill", _8 as "whiteGreenPill" }
